import React from "react";
import { X } from "lucide-react";
import "./Categories.css";

export default function DeleteModal({
  isOpen,
  onClose,
  onConfirm,
  loading,
  error,
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="delete-modal-card">

        <button
          className="modal-close"
          onClick={onClose}
          disabled={loading}
        >
          <X size={18} />
        </button>

        <h3>Are you sure?</h3>
        <p>This category will be permanently deleted.</p>

        {error && (
          <div className="error-text">
            {error}
          </div>
        )}

        <div className="delete-actions">
          <button
            className="cancel-btn"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="confirm-delete-btn"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}